"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MediaDisclaimerText = exports.MediaDisclaimer = void 0;
var _IconLibrary = require("./../../packages/IconLibrary");
var _Disclaimer = _interopRequireDefault(require("./../Disclaimer"));
var _Text = _interopRequireDefault(require("./../Text"));
var _index = _interopRequireDefault(require("./index.styled"));
var _jsxRuntime = require("react/jsx-runtime");
const MediaDisclaimerText = function (_ref) {
  let {
    text,
    position,
    ...props
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.MediaDisclaimer, {
    $position: position,
    ...props,
    "data-testid": "MediaDisclaimerText",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      children: text
    })
  });
};
exports.MediaDisclaimerText = MediaDisclaimerText;
const MediaDisclaimer = function (_ref2) {
  let {
    text,
    position,
    color,
    tooltip = {},
    fullscreen,
    className
  } = _ref2;
  const TooltipIcon = /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconLibrary.InfoIcon, {
    fill: tooltip.theme,
    iconText: tooltip.theme === "black" ? "white" : "black",
    style: {
      width: "20px",
      height: "20px"
    }
  });
  const noPosition = !position && !tooltip.position;
  const rightSlot = position === "right" || tooltip.position === "right";
  const leftSlot = position === "left" || tooltip.position === "left" || noPosition;
  const centerSlot = position === "center" || tooltip.position === "center";
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [rightSlot &&
    /*#__PURE__*/
    //  @ts-ignore
    (0, _jsxRuntime.jsx)(_index.default.DisclaimerOuterContainer, {
      className: className,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.DisclaimerInnerContainer, {
        $position: "right",
        children: [text && position === "right" && /*#__PURE__*/(0, _jsxRuntime.jsx)(MediaDisclaimerText, {
          text: text,
          position: position,
          color: color,
          fullscreen: fullscreen
        }), tooltip.message && tooltip.position === "right" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Disclaimer.default, {
          backgroundColor: tooltip.theme,
          text: tooltip.message,
          placement: "left",
          children: TooltipIcon
        })]
      })
    }), leftSlot &&
    /*#__PURE__*/
    //  @ts-ignore
    (0, _jsxRuntime.jsx)(_index.default.DisclaimerOuterContainer, {
      className: className,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.DisclaimerInnerContainer, {
        $position: "left",
        children: [text && (position === "left" || !position) && /*#__PURE__*/(0, _jsxRuntime.jsx)(MediaDisclaimerText, {
          text: text,
          position: position,
          color: color,
          fullscreen: fullscreen
        }), tooltip.message && (tooltip.position === "left" || !tooltip.position) && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Disclaimer.default, {
          backgroundColor: tooltip.theme,
          text: tooltip.message,
          placement: "right",
          children: TooltipIcon
        })]
      })
    }), centerSlot &&
    /*#__PURE__*/
    //  @ts-ignore
    (0, _jsxRuntime.jsx)(_index.default.DisclaimerOuterContainer, {
      className: className,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_index.default.DisclaimerInnerContainer, {
        $position: "center",
        children: [text && position === "center" && /*#__PURE__*/(0, _jsxRuntime.jsx)(MediaDisclaimerText, {
          text: text,
          position: position,
          color: color,
          fullscreen: fullscreen
        }), tooltip.message && tooltip.position === "center" && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Disclaimer.default, {
          backgroundColor: tooltip.theme,
          text: tooltip.message,
          placement: "top",
          children: TooltipIcon
        })]
      })
    })]
  });
};
exports.MediaDisclaimer = MediaDisclaimer;
var _default = exports.default = MediaDisclaimer;